@media (prefers-color-scheme: dark) {
  .exception-row {
    border-bottom-color: var(--ion-color-dark-shade);
  }
}


